<template>
  <div>
    <DataTable 
      :value="projects" 
      rowHover 
      class="p-datatable-lg projectsTable" 
      dataKey="id" 
      :filters="filters" 
      :loading="loading"
    >
    <template #header>
      <div class="p-d-flex p-jc-between">
        <div class="p-field-checkbox p-mb-0">
            <label for="inactive" class="p-mr-2 p-mt-1 p-ml-0">Tidligere prosjekter</label>
            <InputSwitch id="inactive" name="inactive" v-model="filters['active']"  />
          </div>
        <Button label="Nytt prosjekt" @click="newProject()"/>
      </div>
    </template>
      <Column field="projectname" header="Navn" sortable>
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['projectname']" 
            class="p-column-filter" 
            placeholder="Søk på prosjektnavn"
          ></InputText>
        </template>
        <template #body="slotProps">
          <p>
            <router-link :to="`/project/${slotProps.data.id}`"> {{ slotProps.data.projectname }}</router-link>
          </p> 
        </template>
      </Column>
      <Column field="postalplace" header="Sted" sortable>
        <template #filter>
          <InputText 
            type="text" 
            v-model="filters['postalplace']" 
            class="p-column-filter" 
            placeholder="Søk på sted"
          ></InputText>
        </template>
      </Column>  
      <template #footer>
        <div class="p-d-flex p-jc-end">
          <Button label="Nytt prosjekt" @click="newProject()"/>
        </div>
      </template>
      <Column field="dateupdated">
        <template #header>
          <p class="p-text-center" v-tooltip.top="'Dato for siste Tømme/Bytte eller Innhent/Avslutte ordre'">Siste aktivitet</p>
        </template>
        <template #body="slotProps">
          <p v-if="slotProps.data.updateddate" class="p-text-center">{{ $moment.unix(slotProps.data.updateddate.seconds).format('ll') }}</p>
          <p v-else-if="slotProps.data.lastUpdated" class="p-text-center">{{ $moment(new Date(slotProps.data.lastUpdated)).format('ll') }}</p>
          <p v-else-if="slotProps.data.createddate" class="p-text-center">{{ $moment.unix(slotProps.data.createddate.seconds).format('ll') }}</p>
        </template>
      </Column>
      <Column field="owner.name" header="Eier" filterMatchMode="equals" sortable>
        <template #body="slotProps">
          <p> 
            <router-link :to="`/employee/${slotProps.data.owner.id}`">{{ slotProps.data.owner.name }}</router-link>
          </p>
        </template>
      </Column>
      <Column field="active" header="Aktiv" filterMatchMode="notEquals"></Column>
    </DataTable>

  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputSwitch from 'primevue/inputswitch';
//import { db } from '@/firebase/db' //KUN FOR COMPANYID

export default {
name: 'projects',
components: {
  DataTable,
  Column,
  InputSwitch,
},

data(){
  return{
    inspect: false,
    expandedRow: false,
    sidebar: false,
    activeProjects: true, 
    inactive: false,
    loading: false,
    filters: {
      active: false
    },
    options: {
      active: [
        {name: 'Pågående', value: "true"},
        {name: 'Avsluttet', value: "false"}
      ]
    }
  }
},

props: {
  employee: {
    type: Boolean,
    default: false,
  }
},

methods:{
  newProject(){
    this.$router.push({path: '/projectAdd'})
  },
},

mounted(){

 //BRUKES FOR Å RETROAKTIVT SETTE COMPANYID PÅ PROSJEKTER
  /**console.log("jehans 121")
  db.collection('projects').get().then(projects => {
    projects.forEach((project) => {
            // doc.data() is never undefined for query doc snapshots
            //console.log(doc.id, " => ", doc.data().owner);
            db.collection('users').doc(project.data().owner).get().then(user => {
              db.collection('projects').doc(project.id).update({
                companyID: user.data().worksatcompany[0]
              })
              .then(() => {
                  console.log("Document successfully updated!");
              })
              .catch((error) => {
                  // The document probably doesn't exist.
                  console.error("Error updating document: ", error);
              });
            })
        });
  })*/

  //this.loading = true 
  this.loading = false
  
  if(this.employee){
    this.$store.dispatch('projects/inspect', { id: this.$route.params.id, type: 'user' }).then(() => {
      this.loading = false
    }) 
  }
  else{
    if(this.company == null)
      return 
      
    this.$store.dispatch('projects/inspect', { id: this.company.organizationnumber, type: 'company' })
    .then(() => {
      this.loading = false
    }) 
  }
  
},

computed: {
  isAdmin(){
    return this.$store.getters['user/isAdmin']
  },
  projects(){
    const projects = this.$store.getters["projects/inspect"]
    return Array.isArray(projects) ? projects : []
  },
  
  company(){
    return this.$store.getters["companies/current"]
  }
}
}
</script>

<style lang="sass">

.projectsTable
  th:last-child, td:last-child
    display: none
  
</style>
